import { Component, EventEmitter, Output, inject } from '@angular/core';
import {
  FormGroup,
  FormBuilder,
  FormsModule,
  ReactiveFormsModule,
} from '@angular/forms';
import { DataConnection } from '@nimmsta/ng-commons-lib/models';
import { DataConnectionService } from '@nimmsta/ng-workflow-lib/services/data-connection';
import dayjs from 'dayjs';
import {
  DEFAULT_JOB_DASHBOARD_RANGE,
  JobDashboardConfiguration,
  JobDashboardRange,
} from './job-dashboard-configuration';
import { TranslatePipe } from '@ngx-translate/core';
import { MultiSelect } from 'primeng/multiselect';
import { Select } from 'primeng/select';
import { PrimeTemplate } from 'primeng/api';
import { DatePicker } from 'primeng/datepicker';
import {
  DASHBOARD_EDITOR_CONTEXT,
  DashboardEditorContext,
  filterAvailableDataConnectionIds,
  isWorkflowTemplateDashboard,
} from '../../../../models/dashboard';

@Component({
  selector: 'app-job-dashboard-form',
  templateUrl: './job-dashboard-form.component.html',
  imports: [
    FormsModule,
    ReactiveFormsModule,
    TranslatePipe,
    MultiSelect,
    Select,
    PrimeTemplate,
    DatePicker,
    TranslatePipe,
  ],
})
export class JobDashboardFormComponent {
  //TODO: Check why any is here
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  data = inject<JobDashboardConfiguration>('formData' as any);
  private fb = inject(FormBuilder);
  private dataConnectionService = inject(DataConnectionService);
  private editorContext = inject<DashboardEditorContext | null>(
    DASHBOARD_EDITOR_CONTEXT,
    { optional: true },
  );

  form: FormGroup;

  @Output() dataChange = new EventEmitter<JobDashboardConfiguration>();

  dataConnections: DataConnection[] = [];

  customRange = JobDashboardRange.CUSTOM;

  rangeOptions = Object.entries(JobDashboardRange).map(([key, value]) => ({
    key,
    value: value as JobDashboardRange,
  }));

  dateRange: Date[] = [];

  isTemplateDashboard = isWorkflowTemplateDashboard(this.editorContext);

  constructor() {
    const data = this.data;

    if (!this.isTemplateDashboard) {
      this.dataConnectionService
        .simpleList()
        .subscribe((connections: DataConnection[]) => {
          connections.sort((a, b) => a.name.localeCompare(b.name));
          this.dataConnections = connections;
          this.removeUnavailableDataConnectionIds(connections);
        });
    }

    this.form = this.fb.group({
      dataConnectionIds: [
        this.isTemplateDashboard ? [] : data.dataConnectionIds || [],
      ],
      title: [data.title || ''],
      description: [data.description || ''],
      range: [data.range || DEFAULT_JOB_DASHBOARD_RANGE],
      from: [data.from || null],
      to: [data.to || null],
    });

    if (data.from && data.to) {
      this.dateRange = [dayjs(data.from).toDate(), dayjs(data.to).toDate()];
    }

    this.form.valueChanges.subscribe((value) => {
      this.dataChange.emit(value);
    });
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  customRangeChange(event: any) {
    this.form.patchValue({
      range: this.customRange,
      from: event[0] ? dayjs(event[0]) : null,
      to: event[1] ? dayjs(event[1]) : null,
    });
  }

  private removeUnavailableDataConnectionIds(connections: DataConnection[]) {
    this.form.patchValue({
      dataConnectionIds: filterAvailableDataConnectionIds(
        this.form.get('dataConnectionIds')?.value,
        connections.map((connection) => connection.id),
      ),
    });
  }
}
